const doc = [({"da":({"js":({"admin":({"highscore_generation_teams":({"table":({"user_id":"Bruger ID", "schools_uni_c_id":"Skolens UNI-C ID"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;